import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AppStore from 'store/AppStore'
import { push } from '@lagunovsky/redux-react-router'
import { arrayOf, getLabel, getObjectLabel, getPropType, objectOf } from '../../utils/StoreUtils'
import { groupBy, keys, orderBy } from 'lodash'
import { nbPerPageLabelShort } from '../../referencial/constants/ReferencialConstants'
import i18n from 'simple-react-i18n'
import {
    STATION_NAME,
    STATION_NAME_ASSOCIATION,
    STATION_QUALITOMETER_NAMES,
    STATION_TYPE,
    STATION_TYPE_NAME,
} from '../../station/constants/StationConstants'
import { getSiteUrl } from '../../utils/mapUtils/SiteTypes'
import Checkbox from '../../components/forms/Checkbox'
import Card from '../card/Card'
import AdministrationAction from '../../administration/actions/AdministrationAction'

import { getI18nTitleDataLength, i18nize } from '../../utils/StringUtil'
import CityDto from '../../referencial/components/city/dto/CityDto'
import { INSTALLATION_TYPES } from '../../installation/constants/InstallationConstants'
import { setStationPointScale, setStationsOpacity } from './mapTreatments/AddingLayers'
import { execByType } from '../../utils/StationUtils'
import ListComponentCheckbox from '../list/tableList/ListComponentCheckbox'
import CMSEventDto from '../../events/dto/CMSEventDto'
import { connect } from 'react-redux'
import { hasValue } from 'utils/NumberUtil'
import SettingDto from 'administration/dto/SettingDto'
import { homeListOfSelectedStations } from 'carto/constants/CartoConstants'
import AccountAction from 'account/actions/AccountAction'
import moment from 'moment'
import { getLogin } from 'utils/SettingUtils'
import { NewTable } from 'components/datatable/NewTable'
import { Grid2 } from '@mui/material'

const nameStationTypes = ['QUALITOMETER', 'PLUVIOMETER', 'PIEZOMETER', 'HYDROMETRIC_STATION', 'PRODUCTION_UNIT', 'DISTRIBUTION_UNIT', 'INSTALLATION', 'CONTACT', 'CONTRIBUTOR', 'other']
const defaultHeaders = ['code', 'city', 'name']

class CartographyStationsPanel extends Component {
    state = {
        stations: [],
        dataLoaded: false,
    }

    componentDidMount() {
        const { login } = this.props

        this.props.fetchSettings(login).then(() => {
            this.setStationsState()
        })
    }

    getNewStationParameter = (stationTypeName) => {
        const { stationsPoints } = this.props
        const { stations } = this.state
        if (stationTypeName === STATION_NAME.QUALITOMETER) {
            return stations.some(s => s.includes('3_')) ?
                stations.filter(s => !s.includes('3_'))
                : [
                    ...stations.filter(s => !s.includes('3_')),
                    ...keys(
                        groupBy(
                            stationsPoints.filter(s => s.typeName === STATION_TYPE_NAME.quality)
                            , 'stationType',
                        ))
                        .map(stationType => `3_${stationType}`),
                ]
        } else if (stationTypeName === STATION_NAME.INSTALLATION) {
            return stations.some(s => s.includes('7_')) ?
                stations.filter(s => !s.includes('7_'))
                : [
                    ...stations.filter(s => !s.includes('7_')),
                    ...keys(
                        groupBy(
                            stationsPoints.filter(s => s.typeName === STATION_TYPE_NAME.installation)
                            , 'installationType',
                        ))
                        .map(stationType => `7_${stationType}`),
                ]
        } else if (stations.includes(stationTypeName) && stationTypeName.includes('3_')) {
            return stations.includes(stationTypeName) ?
                stations.filter(s => s !== stationTypeName)
                : [
                    ...stations,
                    stationTypeName,
                ]
        } else if (stations.includes(stationTypeName) && stationTypeName.includes('7_')) {
            return stations.includes(stationTypeName) ?
                stations.filter(s => s !== stationTypeName)
                : [
                    ...stations,
                    stationTypeName,
                ]
        }
        return stations.includes(stationTypeName) ?
            stations.filter(s => s !== stationTypeName)
            : [
                ...stations,
                stationTypeName,
            ]
    }

    saveCartographyStations = (stationTypeName) => {
        const { login = getLogin(), settings } = this.props
        const newStations = this.getNewStationParameter(stationTypeName)
        const stationsString = newStations.join() || ''

        const filterSettings = settings.filter(o => o.parameter !== homeListOfSelectedStations)
        const newSettings = [ ...filterSettings, {
            login,
            parameter: homeListOfSelectedStations,
            updateDate: moment().valueOf(),
            value: stationsString,
        }]

        this.setState({ stations: newStations })
        this.props.updateSettingUser(login, newSettings)
    }

    getSelectedStationsParameter = () => {
        const { settings } = this.props
        const selectedStationsParameter = (settings.find(s => s.parameter === homeListOfSelectedStations) || {}).value
        return selectedStationsParameter
    }

    getStationsStations = () => {
        const selectedStationsParameter = this.getSelectedStationsParameter()
        if (selectedStationsParameter?.length >= 0) {
            return selectedStationsParameter
        }
        return null
    }

    setStationsState = () => {
        const stringStations = this.getStationsStations()
        const stations = stringStations === null ? nameStationTypes : stringStations.length > 0 ? stringStations.split(',') : []
        this.setState({ stations, dataLoaded: true })
    }

    getLayerType = (typeName) => {
        return STATION_NAME_ASSOCIATION[typeName]
    }

    handleChangeVisible(typeName, v) {
        const { stationsPoints } = this.props
        if (this.props.onChangeVisible) {
            const layerType = this.getLayerType(typeName)
            execByType(typeName, {
                quality: () => {
                    const qualityTypes = groupBy(
                        stationsPoints.filter(s => s.typeName === STATION_TYPE_NAME.quality)
                        , 'stationType',
                    )
                    this.props.onChangeVisible(keys(qualityTypes).map(qualitoType => `3_${qualitoType}`), v)
                    this.props.setSelectedSearchValues(this.props.checkboxesType, keys(qualityTypes).reduce((acc, qualitoType) => ({ ...acc, [`3_${qualitoType}`]: { enabled: v } }), {}))
                },
                installation: () => {
                    const installationTypes = groupBy(
                        stationsPoints.filter(s => s.typeName === STATION_TYPE_NAME.installation)
                        , 'installationType',
                    )
                    this.props.onChangeVisible(keys(installationTypes).map(installationType => `7_${installationType}`), v)
                    this.props.setSelectedSearchValues(this.props.checkboxesType, keys(installationTypes).reduce((acc, installationType) => ({ ...acc, [`7_${installationType}`]: { enabled: v } }), {}))
                },
                default: () => {
                    if (layerType) {
                        this.props.onChangeVisible([layerType])
                        this.props.setSelectedSearchValues(this.props.checkboxesType, {
                            [layerType]: { enabled: v },
                        })
                    }
                },
            })
            this.saveCartographyStations(layerType)
        }
    }

    getQualitometersByStationTypes = (qualitometers) => {
        const groupedQualitos = groupBy(qualitometers, 'stationType')
        const tables = keys(groupedQualitos).map(stationType => {
            const foundType = keys(STATION_TYPE).find(t => STATION_TYPE[t] == stationType)
            return {
                title: (
                    <div className='col s12'>
                        <Grid2 container alignItems='center' sx={{ padding: '0.5rem 0' }}>
                            <Grid2 size={2} offset={1}>
                                <img src={getSiteUrl(`QUALITOMETER${foundType ? `_${foundType}` : ''}`)} style={{ height: '3rem' }} />
                            </Grid2>
                            <Grid2 size={9}>
                                <b style={{ fontSize: '1.2rem' }}>{`${getLabel(STATION_QUALITOMETER_NAMES, stationType)} (${groupedQualitos[stationType].length})`}</b>
                            </Grid2>
                        </Grid2>
                    </div>
                ),
                checkbox: (
                    <div className='padding-top-1 row no-margin valign-wrapper' onClick={(e) => {
                        e.preventDefault()
                        const newValue = !this.props.visible[`3_${stationType}`]
                        const qualitoLayer = newValue ? { 3: { enabled: true } } : {}
                        setStationsOpacity(groupedQualitos[stationType], newValue ? 1 : 0)
                        this.props.onChangeVisible([`3_${stationType}`, newValue && !this.props.visible[3] ? '3' : null])
                        this.props.setSelectedSearchValues(this.props.checkboxesType, {
                            [`3_${stationType}`]: { enabled: newValue },
                            ...qualitoLayer,
                        })
                        this.saveCartographyStations(`3_${stationType}`)
                    }}
                    >
                        <Checkbox checked={this.props.visible[`3_${stationType}`]} />
                    </div>
                ),
                component: (
                    <NewTable
                        rows={groupedQualitos[stationType]}
                        rowsPerPageOptions={nbPerPageLabelShort}
                        onMouseEnter={(station) => setStationPointScale(station, true)}
                        onMouseLeave={(station) => setStationPointScale(station, false)}
                        headers={this.props.tableHeaders || defaultHeaders }
                        onClickRow={this.props.onListElementClick || ((s) => AppStore.dispatch(push(`/station/quality/${s.id}`)))}
                    />
                ),
            }
        })
        return <ListComponentCheckbox tables={tables} accordion />
    }

    getInstallationsByStationTypes = (installations) => {
        const groupedInstallations = groupBy(installations, 'installationType')
        const tables = keys(groupedInstallations).map(stationType => {
            const foundTypeImg = INSTALLATION_TYPES.find(it => it.code === parseInt(stationType))?.img || STATION_NAME.INSTALLATION
            return {
                title: (
                    <div className='col s12'>
                        <Grid2 container alignItems='center' sx={{ padding: '0.5rem 0' }}>
                            <Grid2 size={2} offset={1}>
                                <img src={getSiteUrl(foundTypeImg)} style={{ height: '3rem' }} />
                            </Grid2>
                            <Grid2 size={9}>
                                <b style={{ fontSize: '1.2rem' }}>{`${getLabel(i18nize(INSTALLATION_TYPES), stationType) || i18n.installation} (${groupedInstallations[stationType].length})`}</b>
                            </Grid2>
                        </Grid2>
                    </div>
                ),
                checkbox: (
                    <div className='padding-top-1 row no-margin valign-wrapper' onClick={(e) => {
                        e.preventDefault()
                        const newValue = !this.props.visible[`7_${stationType}` || '-1']
                        const installationLayer = newValue ? { 7: { enabled: true } } : {}
                        setStationsOpacity(groupedInstallations[stationType], newValue ? 1 : 0)
                        this.props.onChangeVisible([`7_${stationType}` || '-1', newValue && !this.props.visible[7] ? '7' : null])
                        const obj = {
                            [`7_${stationType}` || '-1']: { enabled: newValue },
                            ...installationLayer,
                        }
                        this.props.setSelectedSearchValues(this.props.checkboxesType, obj)
                        this.saveCartographyStations(`7_${stationType}` || '-1')
                    }}
                    >
                        <Checkbox checked={this.props.visible[`7_${stationType}` || '-1']} />
                    </div>
                ),
                component: (
                    <NewTable
                        rows={groupedInstallations[stationType]}
                        rowsPerPageOptions={nbPerPageLabelShort}
                        onMouseEnter={(station) => setStationPointScale(station, true)}
                        onMouseLeave={(station) => setStationPointScale(station, false)}
                        headers={this.props.tableHeaders || defaultHeaders }
                        onClickRow={this.props.onListElementClick || ((s) => AppStore.dispatch(push(`/station/installation/${s.id}`)))}
                    />
                ),
            }
        })
        return <ListComponentCheckbox tables={tables} accordion />
    }

    getCheckedType = (stations, typeName) => {
        const { visible } = this.props
        switch (typeName) {
            case STATION_TYPE_NAME.installation:
                const instTypes = groupBy(stations, 'installationType')
                return keys(instTypes).some(key => visible[`7_${key}`])
            case STATION_TYPE_NAME.quality:
                const qualitoTypes = groupBy(stations, 'stationType')
                return keys(qualitoTypes).some(key => visible[`3_${key}`])
            default:
                return visible[this.getLayerType(typeName)]
        }
    }

    getTableList = (groupedStations) => {
        const tables = keys(groupedStations).map(typeName => {
            const markerIcon = groupedStations[typeName][0].markerIcon
            const titleValues = (() => {
                switch (typeName) {
                    case STATION_TYPE_NAME.quality:
                        return {
                            singleTitle: i18n.qualitometer,
                            pluralTitle: i18n.qualitometers,
                            icon: markerIcon ? `data:image/svg+xml;utf8,${markerIcon}` : getSiteUrl('QUALITOMETER'),
                        }
                    case STATION_TYPE_NAME.piezometry:
                        return {
                            singleTitle: i18n.piezometer,
                            pluralTitle: i18n.piezometers,
                            icon: markerIcon ? `data:image/svg+xml;utf8,${markerIcon}` : getSiteUrl('PIEZOMETER'),
                        }
                    case STATION_TYPE_NAME.hydrometry:
                        return {
                            singleTitle: i18n.hydrometricStation,
                            pluralTitle: i18n.hydrometricStations,
                            icon: markerIcon ? `data:image/svg+xml;utf8,${markerIcon}` : getSiteUrl('HYDROMETRIC_STATION'),
                        }
                    case STATION_TYPE_NAME.pluviometry:
                        return {
                            singleTitle: i18n.pluviometer,
                            pluralTitle: i18n.pluviometers,
                            icon: markerIcon ? `data:image/svg+xml;utf8,${markerIcon}` : getSiteUrl('PLUVIOMETER'),
                        }
                    case STATION_TYPE_NAME.installation:
                        return {
                            singleTitle: i18n.installation,
                            pluralTitle: i18n.installations,
                            icon: markerIcon ? `data:image/svg+xml;utf8,${markerIcon}` : getSiteUrl('INSTALLATION'),
                        }
                    case STATION_TYPE_NAME.productionUnit:
                        return {
                            singleTitle: i18n.productionUnit,
                            pluralTitle: i18n.productionUnit,
                            icon: markerIcon ? `data:image/svg+xml;utf8,${markerIcon}` : getSiteUrl('PRODUCTION_UNIT'),
                        }
                    case 'contact':
                        return {
                            singleTitle: i18n.contact,
                            pluralTitle: i18n.contacts,
                            icon: markerIcon ? `data:image/svg+xml;utf8,${markerIcon}` : getSiteUrl('CONTACT'),
                        }
                    case 'contributor':
                        return {
                            singleTitle: i18n.contributor,
                            pluralTitle: i18n.contributors,
                            icon: markerIcon ? `data:image/svg+xml;utf8,${markerIcon}` : getSiteUrl('CONTRIBUTOR'),
                        }
                    case 'samplePoint':
                        return {
                            singleTitle: i18n.samplePoint,
                            pluralTitle: i18n.samplePoints,
                            icon: markerIcon ? markerIcon : getSiteUrl('SAMPLE_POINT'),
                        }
                    default:
                        return undefined
                }
            })()

            const stations = orderBy(groupedStations[typeName].map(s => ({ ...s, name: hasValue(s.name?.value) ? s.name?.value : s.name || '', code: s.code || s.id, city: getObjectLabel(this.props.citiesIndex[s.townCode || s.cityCode], 'labelWithCode') })), s => s.city ? s.city : 'ZZZ')

            const onClickElement = ((s) => {
                if (typeName === 'contact' || typeName === 'contributor') {
                    return AppStore.dispatch(push(`/referencial/${s.typeName}/${s.id}`))
                }
                if (typeName === 'samplePoint') {
                    return () => {}
                }
                return AppStore.dispatch(push(`/station/${s.typeName}/${s.id}`))
            })

            const component = (() => {
                switch (typeName) {
                    case STATION_TYPE_NAME.quality:
                        return this.getQualitometersByStationTypes(stations)
                    case STATION_TYPE_NAME.installation:
                        return this.getInstallationsByStationTypes(stations)
                    default:
                        return (
                            <NewTable
                                rows={stations}
                                rowsPerPageOptions={typeName !== 'samplePoint' ? nbPerPageLabelShort : undefined }
                                onMouseEnter={(station) => setStationPointScale(station, true)}
                                onMouseLeave={(station) => setStationPointScale(station, false)}
                                headers={this.props.tableHeaders || defaultHeaders }
                                onClickRow={this.props.onListElementClick || ((s) => onClickElement(s))}
                            />
                        )
                }
            })()
            if (!titleValues) {
                return {}
            }
            return {
                title: (
                    <div className='col s12' >
                        <div className='row no-margin valign-wrapper padding-top-1 padding-bottom-1'>
                            <div className='col s2 center-align'>
                                <div className='iconeTypeResearchWrapper'>
                                    <img src={titleValues.icon} className='responsive-img iconeTypeResearch' />
                                </div>
                            </div>
                            <div className='col s10 no-padding'>
                                <h6 className='bold font-size-16'>
                                    {`${groupedStations[typeName].length === 1 ? titleValues.singleTitle : titleValues.pluralTitle} (${groupedStations[typeName].length})`}
                                </h6>
                            </div>
                        </div>
                    </div>
                ),
                checkbox: (
                    <div
                        className='padding-top-1 row no-margin valign-wrapper'
                        onClick={(e) => {
                            e.preventDefault()
                            this.handleChangeVisible(typeName, !this.getCheckedType(stations, typeName))
                        }}
                    >
                        <Checkbox checked={this.getCheckedType(stations, typeName)} onClick={v => this.handleChangeVisible(typeName, v)} />
                    </div>
                ),
                component,
            }
        })
        return <ListComponentCheckbox tables={tables} accordion />
    }

    getTitle = (length) => {
        const title = getI18nTitleDataLength(i18n.availableStation, i18n.availableStations, length)
        return (<Card className='padding-top-1 inline-block width-100' title={`${length} ${title}`}/>)
    }

    render() {
        const { dataLoaded } = this.state
        const { noStationsPanelTitle } = this.props
        if (dataLoaded) {
            if (this.props.stationsPoints.length) {
                const groupedStations = groupBy(this.props.stationsPoints, 'typeName')
                const nbStations = this.props.stationsPoints.length
                return (
                    <div style={{ position: 'static' }}>
                        { !noStationsPanelTitle && this.getTitle(nbStations)}
                        <div className='padding-top-1' style={{ position: 'static' }}/>
                        {this.getTableList(groupedStations)}
                    </div>
                )
            }
            return (
                <div className='col s12'>
                    <h5 className='center-align'>{i18n.noAssociatedStations}</h5>
                </div>
            )
        }
        return null
    }
}

CartographyStationsPanel.propTypes = {
    stationsPoints: getPropType('qualitometers'),
    noStationsPanelTitle: PropTypes.bool,
    onChangeVisible: PropTypes.onChangeVisible,
    visible: PropTypes.shape({
        6: PropTypes.bool,
        2: PropTypes.bool,
        7: PropTypes.bool,
        1: PropTypes.bool,
        4: PropTypes.bool,
        5: PropTypes.bool,
        3: PropTypes.bool,
        '7_0': PropTypes.bool,
        '7_1': PropTypes.bool,
        '7_2': PropTypes.bool,
        '7_3': PropTypes.bool,
        '7_4': PropTypes.bool,
        '7_5': PropTypes.bool,
        '7_6': PropTypes.bool,
        '7_7': PropTypes.bool,
        '7_8': PropTypes.bool,
        '7_9': PropTypes.bool,
        '7_10': PropTypes.bool,
        '7_11': PropTypes.bool,
        '7_12': PropTypes.bool,
        '7_13': PropTypes.bool,
        '7_14': PropTypes.bool,
        '7_16': PropTypes.bool,
        '7_17': PropTypes.bool,
        '7_18': PropTypes.bool,
        '7_20': PropTypes.bool,
        '7_-1': PropTypes.bool,
        '3_0': PropTypes.bool,
        '3_1': PropTypes.bool,
        '3_2': PropTypes.bool,
        '3_3': PropTypes.bool,
        '3_4': PropTypes.bool,
        '3_5': PropTypes.bool,
        '3_6': PropTypes.bool,
        '3_7': PropTypes.bool,
        '3_8': PropTypes.bool,
        contact: PropTypes.bool,
        CONTACT: PropTypes.bool,
        contributor: PropTypes.bool,
        CONTRIBUTOR: PropTypes.bool,
    }),
    citiesIndex: objectOf(CityDto),
    tableHeaders: PropTypes.arrayOf(PropTypes.string),
    onListElementClick: PropTypes.func,
    checkboxesType: PropTypes.string,
    pollutionPanel: PropTypes.bool,
    cmsEvents: arrayOf(CMSEventDto),
    setSelectedSearchValues: PropTypes.func,
    fetchSettings: PropTypes.func,
    updateSettingUser: PropTypes.func,
    updateSetting: PropTypes.func,
    settings: PropTypes.arrayOf(PropTypes.instanceOf(SettingDto)),
    login: PropTypes.string,
}

const mapStateToProps = store => {
    return {
        settings: store.AdministrationReducer.userSettings,
    }
}

const mapDispatchToProps = {
    setSelectedSearchValues: AdministrationAction.setSelectedSearchValues,
    fetchSettings: AdministrationAction.fetchSettings,
    updateSettingUser: AccountAction.updateSettings,
    updateSetting: AdministrationAction.updateSetting,
}

export default connect(mapStateToProps, mapDispatchToProps)(CartographyStationsPanel)
